// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"9a1df862","444":"a63079f5","635":"b4461da0"}[chunkId] + ".chunk.js";
};